'use client';

import {useState} from 'react';
import CreateListSection from '../CreateListSection';
import ResponsiveModal from '../ResponsiveModal';

type Props = {
  children: React.ReactNode;
};

const CreateListModal = ({children}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ResponsiveModal trigger={children} title="Create new list" setIsOpen={setIsOpen} isOpen={isOpen}>
      <CreateListSection onClose={() => setIsOpen(false)} />
    </ResponsiveModal>
  );
};

export default CreateListModal;
